'use strict';
const angular = require('angular');

export class eformResultTableLinkComponent {
  /*@ngInject*/
  constructor($uibModal, EFormsService, EFormResultsService) {
    this.$uibModal = $uibModal;

    this.EFormsService = EFormsService;
    this.EFormResultsService = EFormResultsService;
  }

  openModal() {
    var that = this;

    var aFields = (this.fields) ? this.fields.split(',').map(field => field.trim()) : [];
    var aFieldNames = (this.fieldNames) ? this.fieldNames.split(',').map(field => field.trim()) : [];

    console.log(aFields);

    this.EFormsService.get({id: this.id}, form => {
      this.title = form.name;
      this.description = form.description;
      this.signatureRequired = form.signatureRequired;

      this.EFormResultsService.getByForm({id: this.id}, data => {
        this.data = data;

        var modalInstance = this.$uibModal.open({
          animation: true,
          component: 'datatableViewer',
          resolve: {
            config: function () {
              return {
                data: that.data.map(entry => {
                  let aRet = [];
                  aFields.forEach(field => aRet.push(entry.data[field]));
                  return aRet;
                }),
                settings: {
                  "columns": aFieldNames
                },
                name: (that.name) ? that.name : that.title
              }
            }
          },
          size: 'lg'
        });
      });

    });
  }
}

export default angular.module('conduuApp.eformResultTableLink', [])
  .component('eformResultTableLink', {
    template: require('./eform-result-table-link.component.html'),
    bindings: {
      id: '@',
      icon: '@',
      text: '@',
      klass: '@',
      name: '@',
      fields: '@',
      fieldNames: '@'
    },
    controller: eformResultTableLinkComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/eform-result-table-link/eform-result-table-link.component.js